import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import { faRefresh } from '@soundxyz/font-awesome/pro-regular-svg-icons/faRefresh';
import { faCircleCheck } from '@soundxyz/font-awesome/pro-solid-svg-icons/faCircleCheck';
import { keyframes, styled } from '@components-shared/src/stitches';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';

const spin = keyframes({
  to: { transform: 'rotate(1turn)' },
});

export function Refresh({
  showRefreshSuccess,
  isFetchingNewActivity,
  refetch,
}: {
  showRefreshSuccess: boolean;
  isFetchingNewActivity: boolean;
  refetch: () => void;
}) {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={showRefreshSuccess ? 'success' : 'regular'}
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
        }}
        exit={{
          opacity: 0,
        }}
        style={{
          marginLeft: 'auto',
        }}
      >
        <RefreshIcon
          size={20}
          css={{
            animation: isFetchingNewActivity ? `${spin} 1s linear infinite` : 'none',
          }}
          onClick={refetch}
          icon={<FontAwesomeIcon icon={showRefreshSuccess ? faCircleCheck : faRefresh} size="lg" />}
        />
      </motion.div>
    </AnimatePresence>
  );
}

const RefreshIcon = styled(IconButton, {
  display: 'none', // Hide on mobile
  '&:hover': {
    backgroundColor: 'transparent',
  },

  '@tablet': {
    display: 'flex',
  },
});
